export default "__VITE_ASSET__CBJscBP5__"